import { IContent } from "@kunduz/data-access-cms-api";
import { HeaderContactOptions } from "@kunduz/ui-components";
import styles from "./headerComponent.module.scss";
import classNames from "classnames";
import {
  DynamicHeader,
  HeaderBannerWithContext,
} from "@kunduz/feature-landing-pages";

export const HeaderComponent = (props: Props) => {
  const {
    headerBannerShow,
    headerContactShow,
    headerShow,
    language,
    headerBannerData,
    headerItems,
    headerContactData,
    isEditing = false,
  } = props;

  const StickyContainer = ({ children }) => {
    if (headerBannerData?.is_sticky || headerContactData?.is_sticky) {
      return (
        <div
          className={classNames(styles.sticky, {
            [styles.isEditing]: isEditing,
          })}
        >
          {children}
        </div>
      );
    }

    return children;
  };

  return (
    <StickyContainer>
      {headerBannerShow && headerBannerData && (
        <HeaderBannerWithContext
          name={headerBannerData.content}
          buttonLabel={headerBannerData.cta_title}
          label={headerBannerData.content}
          url={headerBannerData.cta_link}
        />
      )}

      {headerContactShow && (
        <HeaderContactOptions items={headerContactData?.items} />
      )}

      {headerShow && headerItems && (
        <DynamicHeader
          headerItems={headerItems}
          headerType={headerItems?.profile || "student"}
          lang={language}
        />
      )}
    </StickyContainer>
  );
};

interface Props {
  headerBannerShow: boolean;
  headerContactShow: boolean;
  headerShow: boolean;
  language: "tr" | "en";
  headerItems?: IContent.HeaderItemsResponse;
  headerBannerData?: IContent.HeaderBannerResponse;
  headerContactData?: IContent.HeaderContactOptionsResponse;
  isEditing?: boolean;
}
